import styled from 'styled-components'
import {Row, ButtonLink} from '@modifi/ui'

export const FooterRow = styled(Row)`
  align-items: center;
  height: inherit;
  display: flex;
  justify-content: ${({
    hasDiscard,
    hasSubmit,
  }: {
    hasDiscard?: boolean
    hasSubmit?: boolean
  }): string => (hasDiscard && hasSubmit ? 'space-between' : 'end')};
  padding: 0 24px;
`

export const DiscardButtonLink = styled(ButtonLink)`
  padding-left: 0;
  &:hover {
    background-color: transparent !important;
  }
`
